if (!customElements.get('tab-switcher')) {
  customElements.define(
    'tab-switcher',
    class TabSwitcher extends HTMLElement {
      constructor() {
        super()
      }

      connectedCallback() {
        this.tabPrefix = this.dataset.prefix;
        this.tabs = this.querySelectorAll(`.${this.tabPrefix}tab`);
        this.tabItems = this.querySelectorAll(`.${this.tabPrefix}tab-item`);

        this.isAnimated = this.dataset.isAnimated === 'true';

        this.tabItems.forEach((it) => {
          const btn = it.querySelector(`.${this.tabPrefix}tab-btn`);
          const tab = this.querySelector(`#${btn.dataset.tabTarget}`);

          btn.addEventListener('click', this.onTabSwitch.bind(this, it, tab));
        });
      }

      onTabSwitch(item, tab) {
        this.tabItems.forEach((it) => it.classList.remove(`${this.tabPrefix}tab-item--active`));
        this.tabs.forEach((t) => t.classList.remove(`${this.tabPrefix}tab--active`));

        if (this.isAnimated) {
          setTimeout(() => {
            tab.classList.remove(`${this.tabPrefix}tab--slide-left`);
            tab.classList.remove(`${this.tabPrefix}tab--slide-right`);

            let isBefore = true
            for (const tabElm of this.tabs) {
              if (tabElm === tab) {
                isBefore = false;
                continue;
              }

              tabElm.classList.toggle(`${this.tabPrefix}tab--slide-left`, isBefore);
              tabElm.classList.toggle(`${this.tabPrefix}tab--slide-right`, !isBefore);
            }
          }, 200);
        }

        item.classList.add(`${this.tabPrefix}tab-item--active`);
        tab.classList.add(`${this.tabPrefix}tab--active`);
      }
    },
  );
}
